<div *ngIf="!isEmpty" class="sq-metadata-item {{itemClasses}}">
    <!-- Icon -->
    <span *ngIf="showIcon && !!item" class="sq-metadata-item-icon sq-icon-{{item}} {{docFormatIconClass}} fa-fw pe-2"
        [title]="label | sqMessage">
    </span>

    <!-- Label (title)-->
    <span *ngIf="showTitle && !!item" class="sq-metadata-item-label pe-2">{{'msg#metadata.item.label' | sqMessage:itemLabelMessageParams}}</span>

    <span class="sq-metadata-item-values" [ngClass]="{collapsed: !!collapsed}" #values>
        <!-- Collapse button -->
        <a *ngIf="collapseRows && needsCollapse" href="#" (click)="toggleCollapse($event)" class="collapse-button me-1">
            <i class="fas fa-fw fa-chevron-{{collapsed? 'right' : 'down'}}"></i>
        </a>

        <!-- Access list metadata -->
        <sq-metadata-access-lists-item *ngIf="isAccessLists; else default" [accessLists]="accessListsData">
        </sq-metadata-access-lists-item>

        <!-- Other types of metadata -->
        <ng-template #default>
            <ng-container *ngIf="isTree; else isNotTree">
                <!-- Tree (displayed as breadcrumbs)-->
                <ng-container *ngFor="let valueItem of valueItems; let $index = index">
                    <ol class="breadcrumb" *ngIf="!!valueItem.parts && valueItem.parts.length > 0">
                        <li *ngFor="let part of valueItem.parts; let $subIndex = index">
                            <a    *ngIf="clickable"  class="badge rounded-pill" [ngClass]="'sq-metadata-item-' + item" href="#" (click)="select($index, $subIndex)">{{part | sqValue:column}}</a>
                            <span *ngIf="!clickable" [ngClass]="'sq-metadata-item-' + item">{{part | sqValue:column}}</span>
                            <span *ngIf="$subIndex < valueItem.parts.length - 1" class="sq-metadata-item-tree-node-separator">{{'msg#metadata.item.treeNodeSeparator' | sqMessage}}</span>
                        </li>
                    </ol>
                    <span *ngIf="$index < valueItems.length - 1" class="sq-metadata-item-tree-separator">{{'msg#metadata.item.treeSeparator' | sqMessage}}</span>
                </ng-container>
            </ng-container>

            <!-- Not a Tree-->
            <ng-template #isNotTree>
                <ng-container *ngIf="clickable; else notTreeNonClickable">
                    <!-- Clickable -->
                    <a  *ngFor="let valueItem of valueItems; let $index = index"
                        class="badge rounded-pill {{'sq-metadata-item-' + item}} me-1"
                        href="#"
                        (click)="select($index)"
                        [attr.title]="(showTitle || entityTooltip)? null : (label | sqMessage)"
                        [sqTooltip]="entityTooltip"
                        [sqTooltipData]="valueItem">{{valueItem | sqValue:column}}
                        <span *ngIf="showCounts && valueItem.count"
                            class="counter rounded-pill bg-light text-black ms-1"
                            [title]="valueItem.count + ' occurrences in document'">{{valueItem.count}}</span>
                    </a>
                </ng-container>
                <ng-template #notTreeNonClickable>
                    <!-- Not clickable-->
                    <ng-container *ngFor="let valueItem of valueItems; let $index = index">
                        <span class="{{'sq-metadata-item-' + item}}"
                            [attr.title]="(showTitle || entityTooltip)? null : (label | sqMessage)"
                            [sqTooltip]="entityTooltip"
                            [sqTooltipData]="valueItem">{{valueItem | sqValue:column}}<!-- This comment is here to avoid including an extra space in the span
                         --><span *ngIf="showCounts && valueItem.count"
                                class="small"
                                [title]="valueItem.count + ' occurrences in document'"> ({{valueItem.count}})</span>
                        </span>
                        <span *ngIf="$index < valueItems.length - 1" class="sq-metadata-item-list-separator">{{'msg#metadata.item.listSeparator' | sqMessage}}</span>
                    </ng-container>
                </ng-template>
            </ng-template>
        </ng-template>
    </span>
    <ng-content></ng-content>
</div>
